import { combineReducers } from "redux";
import cart from "../common/reducers/cart";
import appShell from "../common/reducers/appShell";
import userInfo from "../common/reducers/userInfo";
import userAddress from "../common/reducers/userAddress";
import productDefinitions from "../common/reducers/productDefinitions";
import specsEditor from "../common/slices/specsEditor/slice";

const rootReducer = combineReducers({
  appShell,
  cart,
  userInfo,
  userAddress,
  productDefinitions,
  specsEditor,
});

export type RootState = ReturnType<typeof rootReducer>;

export default rootReducer;
